module.exports = __webpack_public_path__ + "img/VEN.5653353b.png";